export default __webpack_public_path__ + "static/media/icon-people.2b8584eb.svg";